export const NIVEAUX = {
  eleve: { label: 'Élevé', badge: 'bg-red-100 text-red-800 border-red-200', case: 'bg-red-500' },
  modere: { label: 'Modéré', badge: 'bg-amber-100 text-amber-800 border-amber-200', case: 'bg-amber-400' },
  faible: { label: 'Faible', badge: 'bg-emerald-100 text-emerald-800 border-emerald-200', case: 'bg-emerald-400' },
};

export const niveau = (p, i) => (p * i >= 9 ? 'eleve' : p * i >= 5 ? 'modere' : 'faible');

export const PROBABILITES = ['Rare', 'Possible', 'Probable', 'Très probable'];
export const IMPACTS = ['Faible', 'Moyen', 'Grave', 'Critique'];
